interface BreadcrumbProps {
  title: string;
  subtitle: string;
  bgText?: string;
}

const Breadcrumb = ({ title, subtitle }: BreadcrumbProps) => {
  return (
    <div 
      className="relative bg-gradient-to-br from-blue-900 to-blue-800 pt-20 pb-8 md:pt-24 md:pb-12 lg:pt-28 lg:pb-16"
      style={{
        background: 'linear-gradient(135deg, #0f1b3c 0%, #0f1b3c 100%)',
        paddingTop: '5rem',
        paddingBottom: '2rem'
      }}
    >
      <div 
        className="container mx-auto px-4"
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}
      >
        <div 
          className="text-center"
          style={{
            textAlign: 'center'
          }}
        >
          <span 
            className="text-orange-400 font-semibold text-xs md:text-sm uppercase tracking-wider mb-3 md:mb-4 block"
            style={{
              color: '#ffba17',
              fontSize: '0.75rem',
              fontWeight: '600',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              marginBottom: '0.75rem',
              display: 'block'
            }}
          >
            {subtitle}
          </span>
          <h1 
            className="text-2xl md:text-4xl lg:text-5xl font-bold text-white"
            style={{
              fontSize: 'clamp(1.5rem, 4vw, 3rem)',
              fontWeight: '700',
              color: 'white',
              lineHeight: '1.2'
            }}
          >
            {title}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
